import { FormattedDate } from "react-intl";

import { logException } from "../../utils/log_exception";

interface Props {
  value: string | number | Date;
}

export const Timestamp: React.FC<Props> = ({ value }) => {
  if (typeof value === "string" && !Number.isFinite(Date.parse(value))) {
    logException(new Error(`Invalid time string: ${value}`));
  } else if (typeof value === "number" && !Number.isFinite(value)) {
    logException(new Error(`Invalid time value: ${value}`));
  } else if (value instanceof Date && !Number.isFinite(value.valueOf())) {
    logException(new Error(`Invalid Date instance: ${value}`));
  }

  return <FormattedDate value={value} year="numeric" month="long" day="numeric" hour="numeric" minute="numeric" />;
};
